import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['trigger', 'dropdown'];

  handleToggle(event) {
    const isOpen = event.newState === 'open';

    this.triggerTargets.forEach((trigger) =>
      trigger.setAttribute('aria-expanded', isOpen),
    );

    if (isOpen) {
      this.dropdownTarget.querySelector("[role='menuitem']")?.focus();
    } else {
      (this.lastTrigger || this.triggerTarget).focus();
    }
  }

  // The trigger button opens/closes the popover natively via
  // popovertarget/popovertargetaction, so a native click->togglePopover()
  // call here would race the browser's own light-dismiss handling (closing
  // then immediately reopening). Just remember which trigger was used, for
  // focus-restoration in handleToggle.
  toggleDropdown(event) {
    this.lastTrigger = event.currentTarget;
  }

  closeDropdown() {
    this.dropdownTarget.hidePopover();
  }

  handleKeydown(event) {
    if (!this.dropdownTarget.matches(':popover-open')) return;

    const focusableItems = Array.from(
      this.dropdownTarget.querySelectorAll("[role='menuitem']"),
    );
    const currentIndex = focusableItems.indexOf(document.activeElement);

    switch (event.key) {
      case 'ArrowDown': {
        event.preventDefault();
        const nextIndex = (currentIndex + 1) % focusableItems.length;
        focusableItems[nextIndex].focus();
        break;
      }
      case 'ArrowUp': {
        event.preventDefault();
        const prevIndex =
          (currentIndex - 1 + focusableItems.length) % focusableItems.length;
        focusableItems[prevIndex].focus();
        break;
      }
      case 'Enter':
      case 'Space': {
        document.activeElement.click();
        break;
      }
      default:
        break;
    }
  }
}
